import React from "react";

export const SealInfoBox: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div className="seal-info-box">{children}</div>
);
